(() => {
  if (window.serlinoGemPagesCartBridge) return;
  window.serlinoGemPagesCartBridge = true;

  const buttonSelector =
    'gp-product-button button[name="add"], gp-product-button .gp-button-atc';

  let previousCount = null;
  let updating = false;

  async function getCart() {
    const root = window.Shopify?.routes?.root || '/';

    const response = await fetch(`${root}cart.js`, {
      credentials: 'same-origin'
    });

    if (!response.ok) {
      throw new Error('Unable to load cart');
    }

    return response.json();
  }

  async function refreshAndOpenDrawer() {
    if (updating) return;
    updating = true;

    try {
      const root = window.Shopify?.routes?.root || '/';

      const response = await fetch(
        `${root}?sections=cart-drawer,cart-icon-bubble`,
        { credentials: 'same-origin' }
      );

      if (!response.ok) {
        throw new Error('Unable to refresh cart sections');
      }

      const sections = await response.json();
      const drawer = document.querySelector('cart-drawer');

      if (!drawer) return;

      if (typeof drawer.renderContents === 'function') {
        drawer.renderContents({ sections });
      } else {
        const parser = new DOMParser();

        if (sections['cart-drawer']) {
          const drawerDocument = parser.parseFromString(
            sections['cart-drawer'],
            'text/html'
          );

          const newInner = drawerDocument.querySelector('.drawer__inner');
          const currentInner = drawer.querySelector('.drawer__inner');

          if (newInner && currentInner) {
            currentInner.replaceWith(newInner);
          }
        }

        if (sections['cart-icon-bubble']) {
          const iconDocument = parser.parseFromString(
            sections['cart-icon-bubble'],
            'text/html'
          );

          const newBubble =
            iconDocument.querySelector('#cart-icon-bubble');

          const currentBubble =
            document.querySelector('#cart-icon-bubble');

          if (newBubble && currentBubble) {
            currentBubble.replaceWith(newBubble);
          }
        }
      }

      window.setTimeout(() => {
        drawer.classList.remove('is-empty');
        drawer.querySelector('.drawer__inner')?.classList.remove('is-empty');
        drawer
          .querySelector('cart-drawer-items')
          ?.classList.remove('is-empty');

        if (typeof drawer.open === 'function') {
          drawer.open();
        }
      }, 100);
    } catch (error) {
      console.error('SerlinoLab cart drawer refresh failed:', error);
    } finally {
      updating = false;
    }
  }

  document.addEventListener(
    'pointerdown',
    async (event) => {
      if (!event.target.closest(buttonSelector)) return;

      try {
        const cart = await getCart();
        previousCount = cart.item_count;
      } catch (error) {
        previousCount = null;
      }
    },
    true
  );

  document.addEventListener(
    'click',
    (event) => {
      if (!event.target.closest(buttonSelector)) return;

      let attempts = 0;

      const interval = window.setInterval(async () => {
        attempts += 1;

        try {
          const cart = await getCart();

          if (previousCount === null || cart.item_count > previousCount) {
            window.clearInterval(interval);
            await refreshAndOpenDrawer();
            return;
          }
        } catch (error) {}

        if (attempts >= 20) {
          window.clearInterval(interval);
        }
      }, 250);
    },
    true
  );
})();

if (!window.serlinoCartIconGuardInitialized) {
  window.serlinoCartIconGuardInitialized = true;

  document.addEventListener(
    'click',
    (event) => {
      const cartTrigger = event.target.closest(
        '#cart-icon-bubble, a.header__icon--cart'
      );

      if (!cartTrigger) return;

      if (
        event.button !== 0 ||
        event.ctrlKey ||
        event.metaKey ||
        event.shiftKey ||
        event.altKey
      ) {
        return;
      }

      event.preventDefault();

      customElements.whenDefined('cart-drawer').then(() => {
        const cartDrawer = document.querySelector('cart-drawer');

        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open(cartTrigger);
        }
      });
    },
    true
  );
}